import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { LoadingController } from 'ionic-angular';

import 'rxjs/add/operator/map';

/*
  Generated class for the GoalsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class GoalsProvider {
  loader: any
  constructor(public gateway: GatewayClientProvider, public http: Http, public loadingCtrl: LoadingController) {

  }
  getGoals(accountId) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getGoals(accountId)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  addGoal(goal) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addGoalv2(goal)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  updateGoal(goal) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updateGoal(goal)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  removeGoal(deletegoal) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.removeGoal(deletegoal)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getAllGoal(customers_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getAllGoal(customers_id)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getPostalData(postCode) {
    this.commonLoader();
    let self = this;
    return new Promise((resolve, reject) => {
      self.http.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + postCode + "&key=AIzaSyBqwG7tb7Z3hwOwiPKk_o9EdTGvnoLswGo")
        .map(res => res.json())
        .subscribe(data => {
          this.loader.dismiss();
          resolve(data);
        }, error => {
          reject(error);
          if (this.loader) {
            this.loader.dismiss();
          }
        });
    });
  }

  upload_Image(image) {
    let self = this;
    let url = "/accounts/uploadtempfile";
    return new Promise((resolve, reject) => {
      self.gateway.upload_image(url, image)
        .then((data) => {
          resolve(data)
        }).catch((err) => {
          reject(err)
        })
    })
  }
  commonLoader() {
    this.loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/goals/goals.ts